// import _ from "lodash";

export const getCountryCode = () => {
  let countryCode = "de";
  let countryOrigin = window.location.origin;
  if (countryOrigin !== null && countryOrigin.lastIndexOf(".") !== -1) {
    countryCode = countryOrigin.slice(
      countryOrigin.lastIndexOf(".") + 1,
      countryOrigin.length
    );
    if (!countryCode || countryCode === "com") {
      countryCode = "de";
    }
  }
  return countryCode;
};

export const getDomainUrl = () => {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const isProd = hostname === "pxm-datacatalog.com";
  const bucket = isProd
    ? "pxm-datacatalog.bayer.com"
    : "qa-pxm-datacatalog.bayer.com";
  return `https://s3.eu-central-1.amazonaws.com/${bucket}/`;
};


